import { render, staticRenderFns } from "./home-patient.vue?vue&type=template&id=5526baf6&scoped=true"
import script from "./home-patient.vue?vue&type=script&lang=js"
export * from "./home-patient.vue?vue&type=script&lang=js"
import style0 from "./home-patient.vue?vue&type=style&index=0&id=5526baf6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5526baf6",
  null
  
)

export default component.exports